// Render the "asked by …" line for a question, given the named askers and
// anonymous count. Caps named askers at 3 ("and N more") and uses the
// "N × Anonymous" form so the all-anonymous case stays grammatical.
export function formatAskers(askers: string[], anon: number): string {
  const named = askers.length;
  if (named === 0 && anon === 0) return "";
  const parts: string[] = [];
  if (named > 0) {
    if (named <= 3) {
      parts.push(...askers);
    } else {
      parts.push(...askers.slice(0, 3), `and ${named - 3} more`);
    }
  }
  if (anon > 0) {
    // Capital-A "Anonymous" with a × multiplier reads cleanly when the
    // count joins a list of named askers ("Henry, Joseph, 2 × Anonymous")
    // and stays grammatical in the all-anonymous case ("3 × Anonymous").
    parts.push(anon === 1 ? "1 × Anonymous" : `${anon} × Anonymous`);
  }
  return parts.join(", ");
}
